import { Construction } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';

interface PlaceholderProps {
  title: string;
}

/** Generic stub for L2 modules not built yet. Replaced feature-by-feature in step 3. */
export function Placeholder({ title }: PlaceholderProps) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <Card>
        <CardContent className="text-muted-foreground flex flex-col items-center gap-3 py-16 text-center">
          <Construction className="size-8" />
          <p className="text-sm">
            <span className="text-foreground font-medium">{title}</span> isn’t built yet.
          </p>
          <p className="max-w-sm text-xs">This module is on the roadmap — see docs/structure.md.</p>
        </CardContent>
      </Card>
    </div>
  );
}
